import CryptoJS from 'crypto-js';


// Default configuration
const DEFAULT_CONFIG = {
    path: '/recommended-items',
    secretKey: 'gigalogy',
    baseUrl: typeof window !== 'undefined' ? window.location.origin : 'https://kurazake-match.gigalogy.com'
};


/* Convert standard Base64 to URL-safe Base64 */
export const toUrlSafeBase64 = (base64String) => {
    return base64String
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};


/* Convert URL-safe Base64 back to standard Base64 */
export const fromUrlSafeBase64 = (urlSafeString) => {
    let base64String = urlSafeString.replace(/-/g, "+").replace(/_/g, "/");
    while (base64String.length % 4) {
        base64String += "=";
    }
    return base64String;
};


/*Encrypt data object into URL-safe string*/
export const encryptData = (data, secretKey = DEFAULT_CONFIG.secretKey) => {
    const jsonData = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(jsonData, secretKey).toString();
    return toUrlSafeBase64(encryptedData);
};


/* Decrypt URL-safe string back to data object */
export const decryptData = (encryptedData, secretKey = DEFAULT_CONFIG.secretKey) => {
    if (!encryptedData) {
        throw new Error('No encrypted data provided');
    }

    try {
        const base64EncryptedData = fromUrlSafeBase64(encryptedData);
        const bytes = CryptoJS.AES.decrypt(base64EncryptedData, secretKey);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;
    } catch (error) {
        throw new Error('Failed to decrypt data: ' + error.message);
    }
};


/* Generate a shareable link with encrypted data */
export const generateShareableLink = (data, options = {}) => {
    const {
        path = DEFAULT_CONFIG.path,
        secretKey = DEFAULT_CONFIG.secretKey,
        baseUrl = DEFAULT_CONFIG.baseUrl,
        paramName = 'token'
    } = options;

    const urlSafeEncryptedData = encryptData(data, secretKey);
    const url = new URL(path, baseUrl);
    url.searchParams.set(paramName, urlSafeEncryptedData);
    return url.toString();
};


/* Extract and decrypt data from a URL token parameter */
export const extractDataFromToken = (token, secretKey = DEFAULT_CONFIG.secretKey) => {
    return decryptData(token, secretKey);
};

/* Extract and decrypt data from current URL */
export const extractDataFromCurrentUrl = (paramName = 'token', secretKey = DEFAULT_CONFIG.secretKey) => {
    if (typeof window === 'undefined') {
        return null;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get(paramName);

    if (!token) {
        return null;
    }

    return decryptData(token, secretKey);
};